<div class="md:m-20 p-5">
    <div class="flex flex-col items-center flex-wrap gap-10 w-4/5 m-auto maintenance-box rounded shadow-lg md:h-[550px] h-[350px]">
        <img class="md:h-auto md:w-1/2"
             alt="Service unavailable"
             src="/images/service-unavailable.svg" />

        <div class="flex flex-col items-center gap-5">
            <div class="text-center">
                <h1 class="md:text-3xl text-center">Service Temporarily Unavailable</h1>
                <p class="mt-2">
                    The GAC Marlog backend service is currently unreachable. Please try again in a few moments
                    or create an IT support ticket via <a class="underline"
                       href="https://servicedesk.gac.com">GAC Service Desk</a> if the problem persists.
                </p>
            </div>

            <button mat-flat-button
                    color="primary"
                    [disabled]="isTimerActive()"
                    (click)="tryAgain()">
                @if (isTimerActive()) {
                Try Again ({{ countdown() }}s)
                } @else {
                Try Again
                }
            </button>
        </div>
    </div>
</div>